module.exports = __webpack_public_path__ + "img/abacus_type_3.5d29ed5b.png";